import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';

import SelectVisitDate from './SelectVisitDate';
import SelectVisitDateCurrentTariff from './SelectVisitDateCurrentTariff';

const SelectVisitDateContainer = (): JSX.Element => {
    const currentTariff = useCtxSelector(state => state.currentTariff);

    if (currentTariff) {
        return <SelectVisitDateCurrentTariff/>;
    }

    return (
        <SelectVisitDate/>
    );
};

export default SelectVisitDateContainer;
